import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-2',
  templateUrl: './2.component.html',
})
export class VbGeneral2Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
